import { handleError } from "../../../utils/helpers";
import { baseApi } from "../../api";
import { ExportDataQuery } from "./misc.types";

export const miscApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    exportData: builder.mutation<void, ExportDataQuery>({
      query: ({ extra, ...payload }) => {
        return {
          url: "export/csv",
          method: "GET",
          params: { ...payload },
          responseHandler: async (response) => {
            const blob = await response.blob();

            let filename;

            switch (payload.type) {
              case "events":
                filename = "Events.csv";
                break;
              case "guests":
                filename = `${extra?.eventName || "Event"} Guest List.csv`;
                break;
              case "userEvents":
                filename = "User Events.csv";
                break;
              case "users":
                filename = "Users.csv";
                break;
              default:
                filename = "Export.csv";
                break;
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            return undefined;
          },
          responseType: "blob",
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          console.log(err);
          handleError(err, true);
        }
      },
    }),
  }),
});

export const { useExportDataMutation } = miscApi;
